import StartSection from "./StartSection";
import {ReactComponent as SectionBg} from  '../assets/hero2.svg'
import DemoSection from "./DemoSection";
import useMediaQuery from '@mui/material/useMediaQuery';
export default function Section2(){
    const isMobile = useMediaQuery("(max-width:768px)");
    return(
        <div className="py-[23.70vh] xs:py-[10vh] s:py-[10vh] relative ">
            { isMobile ?
            <SectionBg preserveAspectRatio='xMidYMid slice' className='w-full top-[105vh]  h-[52.777vh] absolute z-0'></SectionBg>
            :
            <SectionBg preserveAspectRatio='none'  className='w-full top-[66vh]  h-[52.777vh] absolute z-0'></SectionBg>
            }
            <StartSection></StartSection>
            <DemoSection></DemoSection>
       </div>
    )
}